var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUsersIcon = function SvgUsersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 170 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.96 91.33c-.16.03-.32.06-.47.09l-2.93.67C31.76 99.93 5 131.392 5 169.002h160c0-38.07-27.41-69.83-63.85-77.19l-1.53-.4C62.75 84.6 52.2 64.84 52.2 64.84",
    stroke: "#203040",
    strokeWidth: 8.061,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.26 70.96a38.225 38.225 0 0 1 0-54.64c15.32-15.09 40.16-15.09 55.48 0a38.225 38.225 0 0 1 0 54.64",
    stroke: "#203040",
    strokeWidth: 8.061,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.899 64.84s-10.46 19.59-46.95 26.49",
    stroke: "#203040",
    strokeWidth: 8.061,
    strokeMiterlimit: 10
  })));
};

export default SvgUsersIcon;